<template>
    <div class="wrap">
        <div class="icon-wrap" @click="closeModal">
            <span class="material-icons">close</span>
        </div>
        <div class="video-wrap">
            <iframe :src="videoSrc" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        videoSrc: String
    },
    mounted () {
        window.addEventListener('keydown', this.handleEvent)
    },
    methods: {
        closeModal () {
            window.removeEventListener('keydown', this.handleEvent)
            this.$emit('close-modal')
        },
        handleEvent (e) {
            console.log(e)
            if (parseInt(e.keyCode) === 27) {
                this.closeModal()
            }
        }
    },
}
</script>

<style scoped lang="scss">
.wrap {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #000000bb;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.video-wrap {
    width: 80%;
    max-height: 100vh;
    height: 80%;
    @media screen and (max-width: 900px) {
        width: 100%;
        height: 50%;
    }
}
.icon-wrap {
    cursor: pointer;
    position: absolute;
    color: #fff;
    top: 3%;
    right: 3%;
}
iframe {
    width: 100%;
    height: 100%;
}
</style>